<template>
  <div id="publishCoupon">
    <kendo-grid ref="grid"
                :auth="true"
                :columns="tableFields"
                :dataUrl="tableUrl"
                :options="tableOptions"
                :size="'none'"
                :message="'쿠폰 발행 내역이 없습니다.'">
    </kendo-grid>
    <fab :linkList="fabLinkList" @download="download()"></fab>
  </div>
</template>

<script>
  import Fab from '@/components/admin/Fab'
  import KendoGrid from 'common/components/KendoGrid'

  export default {
    name: 'publish-coupon',
    components: {
      Fab,
      KendoGrid
    },
    data () {
      return {
        fabLinkList: [
          {
            id: 'download',
            tooltip: '다운로드',
            callback: 'download',
            src: require('../../assets/svg/ic-download.svg')
          }
        ],
        tableFields: [
          {
            field: 'id',
            title: '번호',
            type: 'string',
            width: '80px',
            filterable: false
          },
          {
            field: 'reg_date',
            title: '발행일',
            type: 'date',
            width: '120px',
            filterable: {
              operators: {
                date: {
                  and: '부터',
                  eq: '같음',
                  gte: '이후',
                  lte: '이전'
                }
              }
            },
            format: '{0:yyyy.MM.dd}'
          },
          {
            field: 'target_user__first_name',
            title: '회원사명',
            type: 'string',
            width: '200px',
            attributes: { class: 'show-tooltip' },
            filterable: { multi: true, search: true },
            template (item) {
              return item.target_user__first_name === null ? '-' : item.target_user__first_name
            }
          },
          {
            field: 'type_string',
            title: '구분',
            type: 'string',
            filterable: { multi: true, search: true },
            width: '120px'
          },
          {
            field: 'name',
            title: '이름',
            type: 'string',
            width: '200px',
            attributes: { class: 'show-tooltip' },
            filterable: { multi: true, search: true },
            template (item) {
              return item.name === '' ? '-' : item.name
            }
          },
          {
            field: 'desc',
            title: '내용',
            type: 'string',
            width: '200px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: false,
            template (item) {
              return item.desc === '' ? '-' : item.desc
            }
          },
          {
            field: 'event_expiration_date',
            title: '등록만료일',
            type: 'date',
            width: '120px',
            filterable: {
              operators: {
                date: {
                  and: '부터',
                  eq: '같음',
                  gte: '이후',
                  lte: '이전'
                }
              }
            },
            format: '{0:yyyy.MM.dd}'
          },
          {
            field: 'period',
            title: '이용기간',
            type: 'string',
            width: '120px',
            filterable: { multi: true, search: true },
            template (item) {
              return item.period === '' || item.type === 'discount' ? '-' : `${item.period}일`
            }
          },
          {
            field: 'point',
            title: '출력가능횟수',
            type: 'string',
            width: '120px',
            filterable: { multi: true, search: true },
            template (item) {
              return item.point === '' || item.type === 'discount' ? '-' : `${item.point}회`
            }
          },
          {
            field: 'promotion_code',
            title: '쿠폰코드',
            type: 'string',
            width: '150px',
            filterable: { extra: false },
            template (item) {
              return item.promotion_code === '' ? '-' : item.promotion_code
            }
          },
          {
            field: 'memo',
            title: '관리자메모',
            type: 'string',
            width: '250px',
            attributes: { class: 'show-tooltip' },
            filterable: { extra: false },
            template (item) {
              return item.memo === '' ? '-' : item.memo
            }
          },
          {
            field: 'reg_by__first_name',
            title: '쿠폰발행자',
            type: 'string',
            width: '120px',
            filterable: { multi: true, search: true },
            template (item) {
              return item.reg_by__first_name === null ? '-' : item.reg_by__first_name
            }
          }
        ],
        tableUrl: `${location.protocol}//${location.hostname.replace('biz', 'api')}/biz/pricing/coupon/`,
        tableOptions: {
          // allowCopy: true,
          // selectable: 'multiple cell',
          excel: {
            fileName: `${moment().format('YYMMDD')}_publish_coupon.xlsx`
          },
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 100,
            pageSizes: [50, 100, 500, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          },
          filterMenuInit: function (e) {
            // 기간검색 필터 일 경우
            if (['reg_date', 'event_expiration_date'].includes(e.field)) {
              const firstValueDropDown = e.container.find('select:eq(0)').data('kendoDropDownList')
              firstValueDropDown.value('gte')
              firstValueDropDown.trigger('change')

              const secondValueDropDown = e.container.find('select:eq(2)').data('kendoDropDownList')
              secondValueDropDown.value('lte')
              secondValueDropDown.trigger('change')
            }
            // 단일검색 필터 일 경우
            if (['promotion_code', 'memo'].includes(e.field)) {
              const firstValueDropDown = e.container.find('select:eq(0)').data('kendoDropDownList')
              firstValueDropDown.value('contains')
              firstValueDropDown.trigger('change')
            }
          }
        }
      }
    },
    methods: {
      download () {
        this.$refs.grid.download()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/PublishCoupon.vue